import script from "./AddUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUser.vue?vue&type=script&setup=true&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=20ae95f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ae95f4"]])

export default __exports__